import React from 'react'
import { Helmet } from 'react-helmet';
import AppLayoutTitle from './appLayoutTitle';
import ComTable from './../components/comTable';


const AppBilling = () => {
    const [dataset, setDataset] = React.useState(undefined);

    const fetchData = async () => {
        setDataset([]);
    }

    React.useEffect(() => {
        fetchData();
    }, []);

    return <>
        <Helmet>
            <title>Billing History | Sparkling Email</title>
        </Helmet>
        <>
            <AppLayoutTitle title="Billing History" />
            <div className="px-3 py-3">
                <div>
                    Review your usage-based billing details in one place.
                </div>
                <div>
                    Provides a complete financial overview, including invoices for
                    translation and/or signature services. View cost breakdowns by
                    domains, download past invoices, and update your payment method.
                </div>
                <br />
                <ComTable
                    data={dataset}
                    isUndefinedIsLoading={true}
                    showCopyToClipboard={true}
                    showCompactMode={true}
                />
            </div>
        </>
    </>
}

export default AppBilling